@file:OptIn(InternalResourceApi::class)

package top.features.venues.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/top.features.venues.generated.resources/"

@delegate:ResourceContentHash(1_960_898_230)
internal val Res.string.venue_action_block: StringResource by lazy {
      StringResource("string:venue_action_block", "venue_action_block", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 58),
      ))
    }

@delegate:ResourceContentHash(824_159_077)
internal val Res.string.venue_action_view_edit: StringResource by lazy {
      StringResource("string:venue_action_view_edit", "venue_action_view_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69, 62),
      ))
    }

@delegate:ResourceContentHash(-2_021_177_781)
internal val Res.string.venue_add_dialog_ai: StringResource by lazy {
      StringResource("string:venue_add_dialog_ai", "venue_add_dialog_ai", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 618, 63),
      ))
    }

@delegate:ResourceContentHash(-554_355_338)
internal val Res.string.venue_add_dialog_ai_create_button: StringResource by lazy {
      StringResource("string:venue_add_dialog_ai_create_button", "venue_add_dialog_ai_create_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132, 81),
      ))
    }

@delegate:ResourceContentHash(-1_995_478_469)
internal val Res.string.venue_add_dialog_ai_create_immediately: StringResource by lazy {
      StringResource("string:venue_add_dialog_ai_create_immediately", "venue_add_dialog_ai_create_immediately", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214, 122),
      ))
    }

@delegate:ResourceContentHash(1_944_009_513)
internal val Res.string.venue_add_dialog_ai_prefill_button: StringResource by lazy {
      StringResource("string:venue_add_dialog_ai_prefill_button", "venue_add_dialog_ai_prefill_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337, 106),
      ))
    }

@delegate:ResourceContentHash(-1_110_077_391)
internal val Res.string.venue_add_dialog_ai_url_label: StringResource by lazy {
      StringResource("string:venue_add_dialog_ai_url_label", "venue_add_dialog_ai_url_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 444, 101),
      ))
    }

@delegate:ResourceContentHash(-219_328_845)
internal val Res.string.venue_add_dialog_ai_url_placeholder: StringResource by lazy {
      StringResource("string:venue_add_dialog_ai_url_placeholder", "venue_add_dialog_ai_url_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 546, 71),
      ))
    }

@delegate:ResourceContentHash(761_585_082)
internal val Res.string.venue_add_dialog_cancel_button: StringResource by lazy {
      StringResource("string:venue_add_dialog_cancel_button", "venue_add_dialog_cancel_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 682, 62),
      ))
    }

@delegate:ResourceContentHash(358_313_816)
internal val Res.string.venue_add_dialog_create_button: StringResource by lazy {
      StringResource("string:venue_add_dialog_create_button", "venue_add_dialog_create_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 745, 82),
      ))
    }

@delegate:ResourceContentHash(144_242_858)
internal val Res.string.venue_add_dialog_empty: StringResource by lazy {
      StringResource("string:venue_add_dialog_empty", "venue_add_dialog_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 828, 78),
      ))
    }

@delegate:ResourceContentHash(-905_099_244)
internal val Res.string.venue_add_dialog_manager_question: StringResource by lazy {
      StringResource("string:venue_add_dialog_manager_question", "venue_add_dialog_manager_question", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 907, 125),
      ))
    }

@delegate:ResourceContentHash(-498_596_957)
internal val Res.string.venue_add_dialog_manual: StringResource by lazy {
      StringResource("string:venue_add_dialog_manual", "venue_add_dialog_manual", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1033, 47),
      ))
    }

@delegate:ResourceContentHash(1_532_474_039)
internal val Res.string.venue_add_dialog_name_label: StringResource by lazy {
      StringResource("string:venue_add_dialog_name_label", "venue_add_dialog_name_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1081, 71),
      ))
    }

@delegate:ResourceContentHash(-1_857_320_933)
internal val Res.string.venue_add_dialog_name_placeholder: StringResource by lazy {
      StringResource("string:venue_add_dialog_name_placeholder", "venue_add_dialog_name_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1153, 77),
      ))
    }

@delegate:ResourceContentHash(545_446_900)
internal val Res.string.venue_add_dialog_no: StringResource by lazy {
      StringResource("string:venue_add_dialog_no", "venue_add_dialog_no", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1231, 35),
      ))
    }

@delegate:ResourceContentHash(187_768_884)
internal val Res.string.venue_add_dialog_question: StringResource by lazy {
      StringResource("string:venue_add_dialog_question", "venue_add_dialog_question", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1267, 125),
      ))
    }

@delegate:ResourceContentHash(-534_177_750)
internal val Res.string.venue_add_dialog_request_button: StringResource by lazy {
      StringResource("string:venue_add_dialog_request_button", "venue_add_dialog_request_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1393, 83),
      ))
    }

@delegate:ResourceContentHash(-1_788_186_435)
internal val Res.string.venue_add_dialog_search_placeholder: StringResource by lazy {
      StringResource("string:venue_add_dialog_search_placeholder", "venue_add_dialog_search_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1477, 79),
      ))
    }

@delegate:ResourceContentHash(1_890_275_889)
internal val Res.string.venue_add_dialog_title: StringResource by lazy {
      StringResource("string:venue_add_dialog_title", "venue_add_dialog_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1557, 66),
      ))
    }

@delegate:ResourceContentHash(-2_147_026_770)
internal val Res.string.venue_add_dialog_yes: StringResource by lazy {
      StringResource("string:venue_add_dialog_yes", "venue_add_dialog_yes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1624, 36),
      ))
    }

@delegate:ResourceContentHash(761_585_082)
internal val Res.string.venue_button_cancel: StringResource by lazy {
      StringResource("string:venue_button_cancel", "venue_button_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1661, 51),
      ))
    }

@delegate:ResourceContentHash(-1_640_425_327)
internal val Res.string.venue_button_create: StringResource by lazy {
      StringResource("string:venue_button_create", "venue_button_create", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1713, 51),
      ))
    }

@delegate:ResourceContentHash(1_595_726_502)
internal val Res.string.venue_button_reject: StringResource by lazy {
      StringResource("string:venue_button_reject", "venue_button_reject", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1765, 51),
      ))
    }

@delegate:ResourceContentHash(-1_552_942_407)
internal val Res.string.venue_button_save_as_draft: StringResource by lazy {
      StringResource("string:venue_button_save_as_draft", "venue_button_save_as_draft", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1817, 86),
      ))
    }

@delegate:ResourceContentHash(1_626_530_311)
internal val Res.string.venue_button_submit: StringResource by lazy {
      StringResource("string:venue_button_submit", "venue_button_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1904, 55),
      ))
    }

@delegate:ResourceContentHash(-2_130_562_339)
internal val Res.string.venue_category_accounting_audit: StringResource by lazy {
      StringResource("string:venue_category_accounting_audit", "venue_category_accounting_audit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1960, 83),
      ))
    }

@delegate:ResourceContentHash(-914_878_095)
internal val Res.string.venue_category_aesthetic_medicine: StringResource by lazy {
      StringResource("string:venue_category_aesthetic_medicine", "venue_category_aesthetic_medicine", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2044, 113),
      ))
    }

@delegate:ResourceContentHash(1_917_805_102)
internal val Res.string.venue_category_auto_parts: StringResource by lazy {
      StringResource("string:venue_category_auto_parts", "venue_category_auto_parts", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2158, 73),
      ))
    }

@delegate:ResourceContentHash(-69_699_553)
internal val Res.string.venue_category_bakery_confectionery: StringResource by lazy {
      StringResource("string:venue_category_bakery_confectionery", "venue_category_bakery_confectionery", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2232, 99),
      ))
    }

@delegate:ResourceContentHash(1_712_227_600)
internal val Res.string.venue_category_bank_credit: StringResource by lazy {
      StringResource("string:venue_category_bank_credit", "venue_category_bank_credit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2332, 86),
      ))
    }

@delegate:ResourceContentHash(1_333_903_486)
internal val Res.string.venue_category_bar_pub: StringResource by lazy {
      StringResource("string:venue_category_bar_pub", "venue_category_bar_pub", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2419, 58),
      ))
    }

@delegate:ResourceContentHash(-972_079_789)
internal val Res.string.venue_category_barbershop: StringResource by lazy {
      StringResource("string:venue_category_barbershop", "venue_category_barbershop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2478, 61),
      ))
    }

@delegate:ResourceContentHash(-995_983_941)
internal val Res.string.venue_category_bookstore_stationery: StringResource by lazy {
      StringResource("string:venue_category_bookstore_stationery", "venue_category_bookstore_stationery", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2540, 95),
      ))
    }

@delegate:ResourceContentHash(30_071_189)
internal val Res.string.venue_category_bowling_billiards: StringResource by lazy {
      StringResource("string:venue_category_bowling_billiards", "venue_category_bowling_billiards", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2636, 84),
      ))
    }

@delegate:ResourceContentHash(1_749_174_075)
internal val Res.string.venue_category_breakfast_brunch: StringResource by lazy {
      StringResource("string:venue_category_breakfast_brunch", "venue_category_breakfast_brunch", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2721, 107),
      ))
    }

@delegate:ResourceContentHash(-1_729_457_700)
internal val Res.string.venue_category_business_consulting: StringResource by lazy {
      StringResource("string:venue_category_business_consulting", "venue_category_business_consulting", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2829, 86),
      ))
    }

@delegate:ResourceContentHash(1_448_578_697)
internal val Res.string.venue_category_car_dealership: StringResource by lazy {
      StringResource("string:venue_category_car_dealership", "venue_category_car_dealership", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2916, 65),
      ))
    }

@delegate:ResourceContentHash(465_378_379)
internal val Res.string.venue_category_car_insurance: StringResource by lazy {
      StringResource("string:venue_category_car_insurance", "venue_category_car_insurance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2982, 108),
      ))
    }

@delegate:ResourceContentHash(514_144_325)
internal val Res.string.venue_category_car_service: StringResource by lazy {
      StringResource("string:venue_category_car_service", "venue_category_car_service", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3091, 78),
      ))
    }

@delegate:ResourceContentHash(647_662_866)
internal val Res.string.venue_category_car_wash: StringResource by lazy {
      StringResource("string:venue_category_car_wash", "venue_category_car_wash", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3170, 55),
      ))
    }

@delegate:ResourceContentHash(614_327_862)
internal val Res.string.venue_category_catering_delivery: StringResource by lazy {
      StringResource("string:venue_category_catering_delivery", "venue_category_catering_delivery", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3226, 100),
      ))
    }

@delegate:ResourceContentHash(-396_684_627)
internal val Res.string.venue_category_cinema: StringResource by lazy {
      StringResource("string:venue_category_cinema", "venue_category_cinema", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3327, 57),
      ))
    }

@delegate:ResourceContentHash(-1_422_468_049)
internal val Res.string.venue_category_cleaning: StringResource by lazy {
      StringResource("string:venue_category_cleaning", "venue_category_cleaning", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3385, 83),
      ))
    }

@delegate:ResourceContentHash(15_378_761)
internal val Res.string.venue_category_clinic_gp: StringResource by lazy {
      StringResource("string:venue_category_clinic_gp", "venue_category_clinic_gp", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3469, 104),
      ))
    }

@delegate:ResourceContentHash(492_600_235)
internal val Res.string.venue_category_clothing_shoes: StringResource by lazy {
      StringResource("string:venue_category_clothing_shoes", "venue_category_clothing_shoes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3574, 73),
      ))
    }

@delegate:ResourceContentHash(1_269_371_446)
internal val Res.string.venue_category_coffee_shop: StringResource by lazy {
      StringResource("string:venue_category_coffee_shop", "venue_category_coffee_shop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3648, 54),
      ))
    }

@delegate:ResourceContentHash(-2_055_508_489)
internal val Res.string.venue_category_construction_company: StringResource by lazy {
      StringResource("string:venue_category_construction_company", "venue_category_construction_company", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3703, 95),
      ))
    }

@delegate:ResourceContentHash(1_752_128_696)
internal val Res.string.venue_category_construction_materials: StringResource by lazy {
      StringResource("string:venue_category_construction_materials", "venue_category_construction_materials", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3799, 113),
      ))
    }

@delegate:ResourceContentHash(-1_146_373_130)
internal val Res.string.venue_category_copywriting_translation: StringResource by lazy {
      StringResource("string:venue_category_copywriting_translation", "venue_category_copywriting_translation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3913, 106),
      ))
    }

@delegate:ResourceContentHash(1_120_168_710)
internal val Res.string.venue_category_cosmetics_perfumery: StringResource by lazy {
      StringResource("string:venue_category_cosmetics_perfumery", "venue_category_cosmetics_perfumery", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4020, 102),
      ))
    }

@delegate:ResourceContentHash(74_512_828)
internal val Res.string.venue_category_cosmetology: StringResource by lazy {
      StringResource("string:venue_category_cosmetology", "venue_category_cosmetology", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4123, 66),
      ))
    }

@delegate:ResourceContentHash(2_057_790_310)
internal val Res.string.venue_category_courier_service: StringResource by lazy {
      StringResource("string:venue_category_courier_service", "venue_category_courier_service", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4190, 82),
      ))
    }

@delegate:ResourceContentHash(-1_452_575_506)
internal val Res.string.venue_category_coworking: StringResource by lazy {
      StringResource("string:venue_category_coworking", "venue_category_coworking", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4273, 60),
      ))
    }

@delegate:ResourceContentHash(-1_910_612_931)
internal val Res.string.venue_category_dentistry: StringResource by lazy {
      StringResource("string:venue_category_dentistry", "venue_category_dentistry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4334, 64),
      ))
    }

@delegate:ResourceContentHash(2_007_422_658)
internal val Res.string.venue_category_dog_training: StringResource by lazy {
      StringResource("string:venue_category_dog_training", "venue_category_dog_training", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4399, 67),
      ))
    }

@delegate:ResourceContentHash(-75_516_378)
internal val Res.string.venue_category_dress_rental: StringResource by lazy {
      StringResource("string:venue_category_dress_rental", "venue_category_dress_rental", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4467, 95),
      ))
    }

@delegate:ResourceContentHash(1_777_289_258)
internal val Res.string.venue_category_dry_cleaning: StringResource by lazy {
      StringResource("string:venue_category_dry_cleaning", "venue_category_dry_cleaning", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4563, 79),
      ))
    }

@delegate:ResourceContentHash(677_807_859)
internal val Res.string.venue_category_electronics: StringResource by lazy {
      StringResource("string:venue_category_electronics", "venue_category_electronics", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4643, 86),
      ))
    }

@delegate:ResourceContentHash(144_242_858)
internal val Res.string.venue_category_empty_results: StringResource by lazy {
      StringResource("string:venue_category_empty_results", "venue_category_empty_results", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4730, 84),
      ))
    }

@delegate:ResourceContentHash(-977_828_828)
internal val Res.string.venue_category_equipment_rental: StringResource by lazy {
      StringResource("string:venue_category_equipment_rental", "venue_category_equipment_rental", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4815, 75),
      ))
    }

@delegate:ResourceContentHash(1_319_401_445)
internal val Res.string.venue_category_event_agency: StringResource by lazy {
      StringResource("string:venue_category_event_agency", "venue_category_event_agency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4891, 115),
      ))
    }

@delegate:ResourceContentHash(-511_874_624)
internal val Res.string.venue_category_event_catering: StringResource by lazy {
      StringResource("string:venue_category_event_catering", "venue_category_event_catering", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5007, 85),
      ))
    }

@delegate:ResourceContentHash(-544_998_350)
internal val Res.string.venue_category_event_photo_video: StringResource by lazy {
      StringResource("string:venue_category_event_photo_video", "venue_category_event_photo_video", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5093, 96),
      ))
    }

@delegate:ResourceContentHash(872_226_043)
internal val Res.string.venue_category_fast_food: StringResource by lazy {
      StringResource("string:venue_category_fast_food", "venue_category_fast_food", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5190, 44),
      ))
    }

@delegate:ResourceContentHash(-177_814_111)
internal val Res.string.venue_category_flower_shop: StringResource by lazy {
      StringResource("string:venue_category_flower_shop", "venue_category_flower_shop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5235, 78),
      ))
    }

@delegate:ResourceContentHash(-619_465_192)
internal val Res.string.venue_category_furniture_decor: StringResource by lazy {
      StringResource("string:venue_category_furniture_decor", "venue_category_furniture_decor", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5314, 70),
      ))
    }

@delegate:ResourceContentHash(1_005_282_515)
internal val Res.string.venue_category_gas_station_ev: StringResource by lazy {
      StringResource("string:venue_category_gas_station_ev", "venue_category_gas_station_ev", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5385, 89),
      ))
    }

@delegate:ResourceContentHash(866_182_506)
internal val Res.string.venue_category_grocery_supermarket: StringResource by lazy {
      StringResource("string:venue_category_grocery_supermarket", "venue_category_grocery_supermarket", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5475, 130),
      ))
    }

@delegate:ResourceContentHash(376_683_326)
internal val Res.string.venue_category_grooming: StringResource by lazy {
      StringResource("string:venue_category_grooming", "venue_category_grooming", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5606, 51),
      ))
    }

@delegate:ResourceContentHash(1_883_698_135)
internal val Res.string.venue_category_hairdresser: StringResource by lazy {
      StringResource("string:venue_category_hairdresser", "venue_category_hairdresser", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5658, 58),
      ))
    }

@delegate:ResourceContentHash(1_066_376_788)
internal val Res.string.venue_category_hall_rental: StringResource by lazy {
      StringResource("string:venue_category_hall_rental", "venue_category_hall_rental", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5717, 66),
      ))
    }

@delegate:ResourceContentHash(1_055_117_942)
internal val Res.string.venue_category_heating_ac: StringResource by lazy {
      StringResource("string:venue_category_heating_ac", "venue_category_heating_ac", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5784, 101),
      ))
    }

@delegate:ResourceContentHash(1_209_892_530)
internal val Res.string.venue_category_host_dj: StringResource by lazy {
      StringResource("string:venue_category_host_dj", "venue_category_host_dj", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5886, 54),
      ))
    }

@delegate:ResourceContentHash(-1_467_852_968)
internal val Res.string.venue_category_hotel_hostel: StringResource by lazy {
      StringResource("string:venue_category_hotel_hostel", "venue_category_hotel_hostel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5941, 75),
      ))
    }

@delegate:ResourceContentHash(771_696_011)
internal val Res.string.venue_category_insurance_company: StringResource by lazy {
      StringResource("string:venue_category_insurance_company", "venue_category_insurance_company", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6017, 84),
      ))
    }

@delegate:ResourceContentHash(1_725_196_899)
internal val Res.string.venue_category_it_support: StringResource by lazy {
      StringResource("string:venue_category_it_support", "venue_category_it_support", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6102, 97),
      ))
    }

@delegate:ResourceContentHash(-1_580_262_804)
internal val Res.string.venue_category_keys_locks: StringResource by lazy {
      StringResource("string:venue_category_keys_locks", "venue_category_keys_locks", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6200, 65),
      ))
    }

@delegate:ResourceContentHash(-1_077_222_968)
internal val Res.string.venue_category_kids_entertainment: StringResource by lazy {
      StringResource("string:venue_category_kids_entertainment", "venue_category_kids_entertainment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6266, 117),
      ))
    }

@delegate:ResourceContentHash(1_074_210_304)
internal val Res.string.venue_category_kindergarten_school: StringResource by lazy {
      StringResource("string:venue_category_kindergarten_school", "venue_category_kindergarten_school", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6384, 90),
      ))
    }

@delegate:ResourceContentHash(-427_445_020)
internal val Res.string.venue_category_laboratory: StringResource by lazy {
      StringResource("string:venue_category_laboratory", "venue_category_laboratory", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6475, 85),
      ))
    }

@delegate:ResourceContentHash(-554_559_153)
internal val Res.string.venue_category_language_courses: StringResource by lazy {
      StringResource("string:venue_category_language_courses", "venue_category_language_courses", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6561, 87),
      ))
    }

@delegate:ResourceContentHash(-781_056_917)
internal val Res.string.venue_category_laser_hair_removal: StringResource by lazy {
      StringResource("string:venue_category_laser_hair_removal", "venue_category_laser_hair_removal", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6649, 105),
      ))
    }

@delegate:ResourceContentHash(-1_242_108_268)
internal val Res.string.venue_category_legal_notary: StringResource by lazy {
      StringResource("string:venue_category_legal_notary", "venue_category_legal_notary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6755, 79),
      ))
    }

@delegate:ResourceContentHash(1_383_803_335)
internal val Res.string.venue_category_manicure_pedicure: StringResource by lazy {
      StringResource("string:venue_category_manicure_pedicure", "venue_category_manicure_pedicure", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6835, 84),
      ))
    }

@delegate:ResourceContentHash(-537_385_838)
internal val Res.string.venue_category_marketing_smm_seo: StringResource by lazy {
      StringResource("string:venue_category_marketing_smm_seo", "venue_category_marketing_smm_seo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6920, 76),
      ))
    }

@delegate:ResourceContentHash(462_466_916)
internal val Res.string.venue_category_meat_dairy_shop: StringResource by lazy {
      StringResource("string:venue_category_meat_dairy_shop", "venue_category_meat_dairy_shop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6997, 90),
      ))
    }

@delegate:ResourceContentHash(-927_637_585)
internal val Res.string.venue_category_moving_service: StringResource by lazy {
      StringResource("string:venue_category_moving_service", "venue_category_moving_service", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7088, 89),
      ))
    }

@delegate:ResourceContentHash(1_811_167_741)
internal val Res.string.venue_category_music_art_school: StringResource by lazy {
      StringResource("string:venue_category_music_art_school", "venue_category_music_art_school", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7178, 119),
      ))
    }

@delegate:ResourceContentHash(-690_183_226)
internal val Res.string.venue_category_night_club: StringResource by lazy {
      StringResource("string:venue_category_night_club", "venue_category_night_club", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7298, 81),
      ))
    }

@delegate:ResourceContentHash(-1_703_714_450)
internal val Res.string.venue_category_online_courses: StringResource by lazy {
      StringResource("string:venue_category_online_courses", "venue_category_online_courses", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7380, 69),
      ))
    }

@delegate:ResourceContentHash(1_813_459_494)
internal val Res.string.venue_category_optics: StringResource by lazy {
      StringResource("string:venue_category_optics", "venue_category_optics", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7450, 45),
      ))
    }

@delegate:ResourceContentHash(-1_761_500_467)
internal val Res.string.venue_category_option_format: StringResource by lazy {
      StringResource("string:venue_category_option_format", "venue_category_option_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7496, 56),
      ))
    }

@delegate:ResourceContentHash(-482_068_461)
internal val Res.string.venue_category_pet_hotel: StringResource by lazy {
      StringResource("string:venue_category_pet_hotel", "venue_category_pet_hotel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7553, 76),
      ))
    }

@delegate:ResourceContentHash(940_218_421)
internal val Res.string.venue_category_pet_shop: StringResource by lazy {
      StringResource("string:venue_category_pet_shop", "venue_category_pet_shop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7630, 63),
      ))
    }

@delegate:ResourceContentHash(-979_160_053)
internal val Res.string.venue_category_pharmacy: StringResource by lazy {
      StringResource("string:venue_category_pharmacy", "venue_category_pharmacy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7694, 47),
      ))
    }

@delegate:ResourceContentHash(-20_943_754)
internal val Res.string.venue_category_pizzeria: StringResource by lazy {
      StringResource("string:venue_category_pizzeria", "venue_category_pizzeria", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7742, 51),
      ))
    }

@delegate:ResourceContentHash(-565_382_706)
internal val Res.string.venue_category_plumbing_electric: StringResource by lazy {
      StringResource("string:venue_category_plumbing_electric", "venue_category_plumbing_electric", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7794, 96),
      ))
    }

@delegate:ResourceContentHash(341_854_699)
internal val Res.string.venue_category_post_delivery: StringResource by lazy {
      StringResource("string:venue_category_post_delivery", "venue_category_post_delivery", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7891, 76),
      ))
    }

@delegate:ResourceContentHash(858_765_887)
internal val Res.string.venue_category_printing_copy: StringResource by lazy {
      StringResource("string:venue_category_printing_copy", "venue_category_printing_copy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7968, 92),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("venue_action_block", Res.string.venue_action_block)
  map.put("venue_action_view_edit", Res.string.venue_action_view_edit)
  map.put("venue_add_dialog_ai", Res.string.venue_add_dialog_ai)
  map.put("venue_add_dialog_ai_create_button", Res.string.venue_add_dialog_ai_create_button)
  map.put("venue_add_dialog_ai_create_immediately", Res.string.venue_add_dialog_ai_create_immediately)
  map.put("venue_add_dialog_ai_prefill_button", Res.string.venue_add_dialog_ai_prefill_button)
  map.put("venue_add_dialog_ai_url_label", Res.string.venue_add_dialog_ai_url_label)
  map.put("venue_add_dialog_ai_url_placeholder", Res.string.venue_add_dialog_ai_url_placeholder)
  map.put("venue_add_dialog_cancel_button", Res.string.venue_add_dialog_cancel_button)
  map.put("venue_add_dialog_create_button", Res.string.venue_add_dialog_create_button)
  map.put("venue_add_dialog_empty", Res.string.venue_add_dialog_empty)
  map.put("venue_add_dialog_manager_question", Res.string.venue_add_dialog_manager_question)
  map.put("venue_add_dialog_manual", Res.string.venue_add_dialog_manual)
  map.put("venue_add_dialog_name_label", Res.string.venue_add_dialog_name_label)
  map.put("venue_add_dialog_name_placeholder", Res.string.venue_add_dialog_name_placeholder)
  map.put("venue_add_dialog_no", Res.string.venue_add_dialog_no)
  map.put("venue_add_dialog_question", Res.string.venue_add_dialog_question)
  map.put("venue_add_dialog_request_button", Res.string.venue_add_dialog_request_button)
  map.put("venue_add_dialog_search_placeholder", Res.string.venue_add_dialog_search_placeholder)
  map.put("venue_add_dialog_title", Res.string.venue_add_dialog_title)
  map.put("venue_add_dialog_yes", Res.string.venue_add_dialog_yes)
  map.put("venue_button_cancel", Res.string.venue_button_cancel)
  map.put("venue_button_create", Res.string.venue_button_create)
  map.put("venue_button_reject", Res.string.venue_button_reject)
  map.put("venue_button_save_as_draft", Res.string.venue_button_save_as_draft)
  map.put("venue_button_submit", Res.string.venue_button_submit)
  map.put("venue_category_accounting_audit", Res.string.venue_category_accounting_audit)
  map.put("venue_category_aesthetic_medicine", Res.string.venue_category_aesthetic_medicine)
  map.put("venue_category_auto_parts", Res.string.venue_category_auto_parts)
  map.put("venue_category_bakery_confectionery", Res.string.venue_category_bakery_confectionery)
  map.put("venue_category_bank_credit", Res.string.venue_category_bank_credit)
  map.put("venue_category_bar_pub", Res.string.venue_category_bar_pub)
  map.put("venue_category_barbershop", Res.string.venue_category_barbershop)
  map.put("venue_category_bookstore_stationery", Res.string.venue_category_bookstore_stationery)
  map.put("venue_category_bowling_billiards", Res.string.venue_category_bowling_billiards)
  map.put("venue_category_breakfast_brunch", Res.string.venue_category_breakfast_brunch)
  map.put("venue_category_business_consulting", Res.string.venue_category_business_consulting)
  map.put("venue_category_car_dealership", Res.string.venue_category_car_dealership)
  map.put("venue_category_car_insurance", Res.string.venue_category_car_insurance)
  map.put("venue_category_car_service", Res.string.venue_category_car_service)
  map.put("venue_category_car_wash", Res.string.venue_category_car_wash)
  map.put("venue_category_catering_delivery", Res.string.venue_category_catering_delivery)
  map.put("venue_category_cinema", Res.string.venue_category_cinema)
  map.put("venue_category_cleaning", Res.string.venue_category_cleaning)
  map.put("venue_category_clinic_gp", Res.string.venue_category_clinic_gp)
  map.put("venue_category_clothing_shoes", Res.string.venue_category_clothing_shoes)
  map.put("venue_category_coffee_shop", Res.string.venue_category_coffee_shop)
  map.put("venue_category_construction_company", Res.string.venue_category_construction_company)
  map.put("venue_category_construction_materials", Res.string.venue_category_construction_materials)
  map.put("venue_category_copywriting_translation", Res.string.venue_category_copywriting_translation)
  map.put("venue_category_cosmetics_perfumery", Res.string.venue_category_cosmetics_perfumery)
  map.put("venue_category_cosmetology", Res.string.venue_category_cosmetology)
  map.put("venue_category_courier_service", Res.string.venue_category_courier_service)
  map.put("venue_category_coworking", Res.string.venue_category_coworking)
  map.put("venue_category_dentistry", Res.string.venue_category_dentistry)
  map.put("venue_category_dog_training", Res.string.venue_category_dog_training)
  map.put("venue_category_dress_rental", Res.string.venue_category_dress_rental)
  map.put("venue_category_dry_cleaning", Res.string.venue_category_dry_cleaning)
  map.put("venue_category_electronics", Res.string.venue_category_electronics)
  map.put("venue_category_empty_results", Res.string.venue_category_empty_results)
  map.put("venue_category_equipment_rental", Res.string.venue_category_equipment_rental)
  map.put("venue_category_event_agency", Res.string.venue_category_event_agency)
  map.put("venue_category_event_catering", Res.string.venue_category_event_catering)
  map.put("venue_category_event_photo_video", Res.string.venue_category_event_photo_video)
  map.put("venue_category_fast_food", Res.string.venue_category_fast_food)
  map.put("venue_category_flower_shop", Res.string.venue_category_flower_shop)
  map.put("venue_category_furniture_decor", Res.string.venue_category_furniture_decor)
  map.put("venue_category_gas_station_ev", Res.string.venue_category_gas_station_ev)
  map.put("venue_category_grocery_supermarket", Res.string.venue_category_grocery_supermarket)
  map.put("venue_category_grooming", Res.string.venue_category_grooming)
  map.put("venue_category_hairdresser", Res.string.venue_category_hairdresser)
  map.put("venue_category_hall_rental", Res.string.venue_category_hall_rental)
  map.put("venue_category_heating_ac", Res.string.venue_category_heating_ac)
  map.put("venue_category_host_dj", Res.string.venue_category_host_dj)
  map.put("venue_category_hotel_hostel", Res.string.venue_category_hotel_hostel)
  map.put("venue_category_insurance_company", Res.string.venue_category_insurance_company)
  map.put("venue_category_it_support", Res.string.venue_category_it_support)
  map.put("venue_category_keys_locks", Res.string.venue_category_keys_locks)
  map.put("venue_category_kids_entertainment", Res.string.venue_category_kids_entertainment)
  map.put("venue_category_kindergarten_school", Res.string.venue_category_kindergarten_school)
  map.put("venue_category_laboratory", Res.string.venue_category_laboratory)
  map.put("venue_category_language_courses", Res.string.venue_category_language_courses)
  map.put("venue_category_laser_hair_removal", Res.string.venue_category_laser_hair_removal)
  map.put("venue_category_legal_notary", Res.string.venue_category_legal_notary)
  map.put("venue_category_manicure_pedicure", Res.string.venue_category_manicure_pedicure)
  map.put("venue_category_marketing_smm_seo", Res.string.venue_category_marketing_smm_seo)
  map.put("venue_category_meat_dairy_shop", Res.string.venue_category_meat_dairy_shop)
  map.put("venue_category_moving_service", Res.string.venue_category_moving_service)
  map.put("venue_category_music_art_school", Res.string.venue_category_music_art_school)
  map.put("venue_category_night_club", Res.string.venue_category_night_club)
  map.put("venue_category_online_courses", Res.string.venue_category_online_courses)
  map.put("venue_category_optics", Res.string.venue_category_optics)
  map.put("venue_category_option_format", Res.string.venue_category_option_format)
  map.put("venue_category_pet_hotel", Res.string.venue_category_pet_hotel)
  map.put("venue_category_pet_shop", Res.string.venue_category_pet_shop)
  map.put("venue_category_pharmacy", Res.string.venue_category_pharmacy)
  map.put("venue_category_pizzeria", Res.string.venue_category_pizzeria)
  map.put("venue_category_plumbing_electric", Res.string.venue_category_plumbing_electric)
  map.put("venue_category_post_delivery", Res.string.venue_category_post_delivery)
  map.put("venue_category_printing_copy", Res.string.venue_category_printing_copy)
}
